import type { FaireProductEntity } from "../../entity_types/product";

export const p_dgebs00f8d: FaireProductEntity = {
  token: "p_dgebs00f8d",
  type: "product",
  name: "Liquid Magnesium Ionic Supplement Drops",
  brandToken: "b_4ce3l13q1j",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0047444a4e0f497fbd44d50fc36ede61a8e9c0b0bf149ed5c085d179ba050075.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fb495954989c16e0aa01b33a9ab1f31a06c5345e8f6e65a24260ebf0e9b66a05.png",
    "https://cdn.faire.com/fastly/30ba6ea694cf3191c41091a6561e1bd60e9c65362699198d12e0c27dc9ec248f.png",
    "https://cdn.faire.com/fastly/4a48a1a4baeee80cc5f5796486c3b351d03f9aa20704eaa0b2ef6f7510f4fd9a.png",
    "https://cdn.faire.com/fastly/6ab106e2bc950282895c6c79726e2c2d0e719ace5d315142137d8838c7d9e630.png",
    "https://cdn.faire.com/fastly/50cf0e14ad76c04f24a6b877003ffdcfda681f77db3afcaf984eebeccfe42166.png",
    "https://cdn.faire.com/fastly/dcd88241be3e54856faa222d50813437c25496b4a850731aed1ab782179c3b32.png",
    "https://cdn.faire.com/fastly/72e186891bd02d36250a3db40da51dd9d346d8dd15e40a2fabea722c4cb80e1b.png",
    "https://cdn.faire.com/fastly/e0b6b25491a45850d286d91ca5ee47c9505b8deabf932dab81c9326182fa9d45.png",
    "https://cdn.faire.com/fastly/0916de6416c7c487f2f878afcee0e0c96b893ca3d43ab86bcc493f4383a1d1d1.png",
    "https://cdn.faire.com/fastly/6594a2039b1b9e8271694638bb48650e38ff8961e50db42d44cf906acf4fa976.png",
  ],
  priceDollars: 17,
  description:
    "Liquid Magnesium Ionic Supplement Drops bring balance to your life by supporting over 300 metabolic reactions within your body. This essential mineral plays a pivotal role in protein synthesis, muscle and nerve relaxation, blood glucose control, blood pressure regulation, and energy production.\n\nEnhance your natural cellular and electrical impulses with the power of magnesium, promoting better sleep, soothing muscles, and improving heart and brain health. With just 4 droppers mixed in juice or a liquid of your choice, you unlock the potential for mental and physical strength while building resistance to illness.\n\nDiscover the essence of wellness in every drop with our Liquid Magnesium Supplement Drops – often referred to as Yoga in a bottle. Ideal for retailers and wholesalers, this 4oz product stands out as a high-quality supplement for overall health and well-being.",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:26.613Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
